var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCart20 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.213,
    height: 36,
    viewBox: "0 0 41.213 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shopping-online",
    d: "M40.5,16.344a3.082,3.082,0,0,0-2.4-1.067H26.941L23.7,4.2a.706.706,0,0,0-1.355.4l3.122,10.68H15.744L18.866,4.6a.706.706,0,0,0-1.355-.4L14.273,15.277H3.03A3,3,0,0,0,.653,16.349,3,3,0,0,0,.069,18.89l3.5,17.466a4.328,4.328,0,0,0,4.071,3.336H34.332a4.172,4.172,0,0,0,3.977-3.378l2.858-17.431A3.083,3.083,0,0,0,40.5,16.344Zm-.728,2.311L36.915,36.086a2.747,2.747,0,0,1-2.584,2.195H7.641a2.9,2.9,0,0,1-2.687-2.2l-3.5-17.466a1.617,1.617,0,0,1,.292-1.369,1.615,1.615,0,0,1,1.285-.555H13.86l-.82,2.806a.707.707,0,0,0,.479.876.717.717,0,0,0,.2.029.706.706,0,0,0,.677-.508l.936-3.2H25.882l.936,3.2a.707.707,0,0,0,.677.508.688.688,0,0,0,.2-.029.706.706,0,0,0,.479-.876l-.82-2.806H38.1a1.622,1.622,0,0,1,1.67,1.967ZM21.313,25.427v9.327a.706.706,0,1,1-1.412,0V25.427a.706.706,0,1,1,1.412,0Zm-7.137,0v9.327a.706.706,0,0,1-1.412,0V25.427a.706.706,0,0,1,1.412,0Zm14.274,0v9.327a.706.706,0,0,1-1.412,0V25.427a.706.706,0,0,1,1.412,0Z",
    transform: "translate(-0.001 -3.693)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCart20, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cart-20.5076821e.svg";
export { ForwardRef as ReactComponent };